import React, { useContext, useReducer, useEffect } from "react";
import PropTypes from "prop-types";

const FormContext = React.createContext();

// use this hook to access form state and dispatch funcs from child components
const useFormContext = () => useContext(FormContext);

// FormProvider passes form state handlers to child components
function FormProvider({ children, initialState, onSubmit, onChange, onFieldChange, formErrors }) {

    const formStateReducer = (state, action) => {
        if (action.type === "file") {
            const file = action.files[0];
            let newstate = null;
            if(!file){
                newstate = { ...state, [action.name]: "" };
            } else {
                newstate = { ...state, [action.name]: file };
            }
            return newstate
        } else if (action.type === "checkbox") {
            if (action.checked) {
                return {
                    ...state,
                    [action.name]: [...state[action.name], action.value],
                }
            } else {
                return {
                    ...state,
                    [action.name]: state[action.name].filter((v) => v !== action.value),
                }
            }
        }
        return { ...state, [action.name]: action.value }
    }

    const [formState, dispatch] = useReducer(formStateReducer, initialState);

    // default onchange function for all form inputs
    const setFormState = (e) => {

        // console.log('FORMSTATECHANGE', e);
         
        const delta = {
            files: e.target.files,
            name: e.target.name,
            type: e.target.type,
            value: e.target.value,
            checked: e.target.checked,
        };
        onFieldChange && onFieldChange(delta);
        dispatch(delta);
    }

    // if the formstate changes, notify the parent form explicitly,
    // children will know through the normal provider situation
    useEffect(() => {
        onChange && onChange(formState);
    }, [formState, onChange])

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formState);
    };

    return (
        <FormContext.Provider
            value={{
                formState,
                formErrors,
                dispatch,
                setFormState,
            }}
        >
            <form onSubmit={handleSubmit}>{children}</form>
        </FormContext.Provider>
    );
}

FormProvider.propTypes = {
    children: PropTypes.node,
    initialState: PropTypes.object,
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    onFieldChange: PropTypes.func,
    formErrors: PropTypes.object,
};

export { FormProvider as default, useFormContext };
